import { CapoPlugin } from "/home/runner/work/global-main-frontend/global-main-frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];